var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DataTable',{staticClass:"stock-lending-table",attrs:{"data-testid":"stock-lending-table","data":_vm.items,"items-per-page":_vm.itemsPerPage,"status":_vm.tableCurrentStatus,"columns":_vm.columns,"has-interaction":""},on:{"on-row-click":_vm.handleOnRowClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }